import type { InitData } from 'tradera/state/init-data/types';

declare global {
    interface Window {
        initData: InitData;
    }
}

/**
 * @returns initData as JSON;
 * Default
 */
const initData = (): InitData => {
    if (typeof window === 'undefined') {
        return {} as InitData;
    } else if (!window.initData) {
        const initDataEL = document.getElementById('init-data');
        if (initDataEL) {
            const data = initDataEL.getAttribute('data-init-data') || '';
            const parsed = JSON.parse(data);
            return parsed;
        } else {
            return {} as InitData;
        }
    } else {
        return window.initData;
    }
};

export default initData();
